import React, { useState } from 'react';
import './Home.css';
import { useLanguage } from '../context/LanguageContext';

const Home = ({ themeMode }) => {
  const { t } = useLanguage();
  const [isAnimationActive, setIsAnimationActive] = useState(false);
  const [animRunKey, setAnimRunKey] = useState(0);

  const handlePlayTerminalAnimation = () => {
    setIsAnimationActive(true);
    setAnimRunKey(prev => prev + 1); // Her tıklamada animasyonu taze baştan oynat
  };

  const handleResetTerminal = () => {
    setIsAnimationActive(false);
  };

  const badgeWords = t('hero.badgeWords') || [
    'Yenilikçi Dijital Dönüşüm',
    'Modern Web Çözümleri',
    'Android Uygulama Geliştirme',
    'Özel Kurumsal Yazılımlar',
    'UI / UX Deneyim Tasarımı'
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // --- KLASİK GÖRÜNÜM HERO (Geleneksel Slider / Banner Tarzı) ---
  if (themeMode === 'classic') {
    return (
      <div id="hero" className="hero-wrapper classic-hero-wrapper">
        {/* Klasik Banner / Afiş Vitrini */}
        <div className="classic-slider-banner">
          <div className="slider-container">
            <div className="slider-text-content">
              <span className="classic-tag">Akinevo Bilişim & Yazılım</span>
              <h1 className="classic-hero-title">
                {t('hero.classicHeadline')}
              </h1>
              <p className="classic-hero-desc">
                {t('hero.classicDesc')}
              </p>
              <div className="classic-btn-group">
                <button className="classic-btn classic-btn-primary" onClick={() => scrollTo('iletisim')}>
                  <i className="fa-solid fa-envelope"></i>
                  <span>{t('hero.contactBtn')}</span>
                </button>
                <button className="classic-btn classic-btn-secondary" onClick={() => scrollTo('hizmetler')}>
                  <i className="fa-solid fa-list-check"></i>
                  <span>{t('hero.exploreBtn')}</span>
                </button>
              </div>
            </div>

            {/* Sağ Taraf: Klasik Şirket Tanıtım Kartı */}
            <div className="classic-banner-card">
              <div className="banner-card-top">
                <div className="banner-icon">
                  <i className="fa-solid fa-building"></i>
                </div>
                <div>
                  <h4>Akinevo Çözüm Merkezi</h4>
                  <p>Profesyonel & Güvenilir Hizmet</p>
                </div>
              </div>
              <ul className="classic-feature-list">
                <li>
                  <i className="fa-solid fa-check"></i>
                  <span>Mobil Uyumlu Kurumsal Web Tasarımı</span>
                </li>
                <li>
                  <i className="fa-solid fa-check"></i>
                  <span>Google Play Store Uyumlu Android Uygulama</span>
                </li>
                <li>
                  <i className="fa-solid fa-check"></i>
                  <span>Arama Motoru (SEO) Optimizasyonu</span>
                </li>
                <li>
                  <i className="fa-solid fa-check"></i>
                  <span>Sözleşme Kapsamında Belirlenen Süre Boyunca Teknik Destek</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Klasik Kurumsal İstatistik Şeridi */}
        <div className="stats-container">
          <div className="stats-wrapper">
            <div className="stat-box">
              <span className="stat-value">2025</span>
              <span className="stat-desc">{t('hero.statFounded')}</span>
            </div>
            <div className="stat-sep"></div>
            <div className="stat-box">
              <span className="stat-value">%100</span>
              <span className="stat-desc">{t('hero.statQuality')}</span>
            </div>
            <div className="stat-sep"></div>
            <div className="stat-box">
              <span className="stat-value">6+</span>
              <span className="stat-desc">{t('hero.statServices')}</span>
            </div>
            <div className="stat-sep"></div>
            <div className="stat-box">
              <span className="stat-value">7/24</span>
              <span className="stat-desc">{t('hero.statSupport')}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // --- MODERN GÖRÜNÜM HERO (Linear / Vercel Estetiği) ---
  return (
    <div id="hero" className="hero-wrapper">
      {/* Ambient Radial Lights */}
      <div className="ambient-glow glow-indigo"></div>
      <div className="ambient-glow glow-cyan"></div>

      <section className="hero-section">
        <div className="hero-container">
          {/* Top Dynamic Sliding Badge */}
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <div className="badge-slider-viewport">
              <div className="badge-marquee-track">
                {badgeWords.map((word, idx) => (
                  <span key={`w1-${idx}`} className="badge-marquee-item">
                    {word}
                    <span className="badge-item-sep">•</span>
                  </span>
                ))}
                {/* Sonsuz kesintisiz döngü için klon küme */}
                {badgeWords.map((word, idx) => (
                  <span key={`w2-${idx}`} className="badge-marquee-item" aria-hidden="true">
                    {word}
                    <span className="badge-item-sep">•</span>
                  </span>
                ))}
              </div>
            </div>
            <i className="fa-solid fa-code badge-icon"></i>
          </div>

          {/* Main Title */}
          <h1 className="hero-title">
            {t('hero.titleP1')} <br />
            <span className="gradient-text">{t('hero.titleHighlight')}</span> {t('hero.titleP2')}
          </h1>

          {/* Description */}
          <p className="hero-description">
            {t('hero.subtitle')}
          </p>

          {/* CTAs */}
          <div className="hero-cta-group">
            <button className="btn btn-primary hero-btn" onClick={() => scrollTo('uygulamalar')}>
              <span>{t('hero.exploreBtn')}</span>
              <i className="fa-solid fa-arrow-right"></i>
            </button>
            <button className="btn btn-secondary hero-btn" onClick={() => scrollTo('hizmetler')}>
              <i className="fa-solid fa-cube"></i>
              <span>{t('nav.services')}</span>
            </button>
            <button className="btn btn-secondary hero-btn contact-btn" onClick={() => scrollTo('iletisim')}>
              <i className="fa-regular fa-envelope"></i>
              <span>{t('nav.contact')}</span>
            </button>
          </div>

          {/* Interactive Tech Mockup Showcase */}
          <div className="hero-showcase">
            <div className="showcase-window">
              <div className="window-header">
                <div className="window-dots">
                  <span className="dot dot-red"></span>
                  <span className="dot dot-yellow"></span>
                  <span className="dot dot-green"></span>
                </div>
                <div className="window-title">akinevo-workspace — bash</div>
                <div className="window-actions">
                  <div className="window-status">
                    <span className="status-live"></span>
                    <span>{isAnimationActive ? 'CORE ENGINE ONLINE' : 'SYSTEM READY'}</span>
                  </div>
                  {isAnimationActive ? (
                    <div className="terminal-actions-group">
                      <button 
                        type="button" 
                        className="terminal-play-btn replay"
                        onClick={handlePlayTerminalAnimation}
                        title="Animasyonu Yeniden Başlat"
                        aria-label="Yeniden Başlat"
                      >
                        <i className="fa-solid fa-rotate-right"></i>
                      </button>
                      <button 
                        type="button" 
                        className="terminal-play-btn close-btn"
                        onClick={handleResetTerminal}
                        title="Konsol Görünümüne Dön"
                        aria-label="Konsola Dön"
                      >
                        <i className="fa-solid fa-terminal"></i>
                      </button>
                    </div>
                  ) : (
                    <button 
                      type="button" 
                      className="terminal-play-btn"
                      onClick={handlePlayTerminalAnimation}
                      title="AKİNEVO Çekirdek Animasyonunu Başlat"
                      aria-label="Animasyonu Başlat"
                    >
                      <i className="fa-solid fa-play"></i>
                    </button>
                  )}
                </div>
              </div>
              <div className={`window-content ${isAnimationActive ? 'animation-active' : ''}`}>
                {isAnimationActive ? (
                  <div key={animRunKey} className="terminal-brand-animation">
                    {/* Yüksek Teknolojili Dönen Çark / Spiral Halka Efekti */}
                    <div className="quantum-spiral-container">
                      <div className="spiral-ring ring-outer-track"></div>
                      <div className="spiral-ring ring-gear-outer"></div>
                      <div className="spiral-ring ring-1"></div>
                      <div className="spiral-ring ring-2"></div>
                      <div className="spiral-ring ring-3"></div>
                      <div className="spiral-core-glow"></div>
                      <div className="spiral-radial-spokes"></div>
                    </div>

                    {/* Tek Tek Ekrana Gelen AKİNEVO Harfleri */}
                    <div className="anim-glitch-wrapper">
                      <div className="anim-brand-logo letter-stagger">
                        <span className="logo-letter" style={{ animationDelay: '0.4s' }}>A</span>
                        <span className="logo-letter" style={{ animationDelay: '0.6s' }}>K</span>
                        <span className="logo-letter letter-i" style={{ animationDelay: '0.8s' }}>İ</span>
                        <span className="logo-letter" style={{ animationDelay: '1.0s' }}>N</span>
                        <span className="logo-letter" style={{ animationDelay: '1.2s' }}>E</span>
                        <span className="logo-letter" style={{ animationDelay: '1.4s' }}>V</span>
                        <span className="logo-letter" style={{ animationDelay: '1.6s' }}>O</span>
                      </div>
                      <div className="anim-brand-sub" style={{ animationDelay: '1.9s' }}>
                        SOFTWARE & NEXT-GEN DIGITAL SOLUTIONS
                      </div>
                    </div>

                    {/* Canlı Çekirdek İstatistikleri */}
                    <div className="anim-code-stream" style={{ animationDelay: '2.7s' }}>
                      <div className="stream-badge-row">
                        <span className="stream-chip"><i className="fa-solid fa-microchip"></i> Quantum Engine: Active</span>
                        <span className="stream-chip"><i className="fa-solid fa-bolt"></i> Latency: 0.1ms</span>
                        <span className="stream-chip"><i className="fa-solid fa-shield-halved"></i> Secured</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="code-line">
                      <span className="code-prefix">$</span>
                      <span className="code-cmd">akinevo</span> create-project --type=web-app --responsive=true
                    </div>
                    <div className="code-output">
                      <span className="output-success">✓ [Frontend]</span> Modern & responsive arayüz hazırlandı.
                    </div>
                    <div className="code-output">
                      <span className="output-success">✓ [Mobile]</span> Android platform desteği sağlandı.
                    </div>
                    <div className="code-output">
                      <span className="output-info">✦ [Akinevo]</span> Hayalinizdeki projeyi birlikte kuralım.
                    </div>
                    
                    {/* Visual Feature Badges */}
                    <div className="showcase-cards">
                      <div className="mini-card">
                        <i className="fa-solid fa-laptop-code"></i>
                        <div>
                          <h4>Modern Web Siteleri</h4>
                          <p>Hızlı, şık ve SEO uyumlu</p>
                        </div>
                      </div>
                      <div className="mini-card">
                        <i className="fa-brands fa-android"></i>
                        <div>
                          <h4>Android Uygulamaları</h4>
                          <p>Google Play Store & APK</p>
                        </div>
                      </div>
                      <div className="mini-card">
                        <i className="fa-solid fa-sliders"></i>
                        <div>
                          <h4>Özel Yazılımlar</h4>
                          <p>İhtiyaca özel panel ve araçlar</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modern Sleek Stats Bar */}
      <div className="stats-container">
        <div className="stats-wrapper">
          <div className="stat-box">
            <span className="stat-value">2025</span>
            <span className="stat-desc">{t('hero.statFounded')}</span>
          </div>
          <div className="stat-sep"></div>
          <div className="stat-box">
            <span className="stat-value">%100</span>
            <span className="stat-desc">{t('hero.statQuality')}</span>
          </div>
          <div className="stat-sep"></div>
          <div className="stat-box">
            <span className="stat-value">6+</span>
            <span className="stat-desc">{t('hero.statServices')}</span>
          </div>
          <div className="stat-sep"></div>
          <div className="stat-box">
            <span className="stat-value">7/24</span>
            <span className="stat-desc">{t('hero.statSupport')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
